import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { WorkBlockerConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { WorkBlockerService } from './api/workBlocker.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class WorkBlockerApiModule {
    public static forRoot(configurationFactory: () => WorkBlockerConfiguration): ModuleWithProviders<WorkBlockerApiModule> {
        return {
            ngModule: WorkBlockerApiModule,
            providers: [ { provide: WorkBlockerConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: WorkBlockerApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('WorkBlockerApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
